import React, { useCallback, useMemo } from 'react';
import { getTypeIcon } from '@atlassian/people-teams-ui';
import { prefixWithContextEntryPoint } from '../../../common/utils/url';
import { useNavigationState } from '../store/main';
const error = new Error('AppConfig is not setup in RSS');
const defaultValue = {
  push: () => {
    throw error;
  },
  replace: () => {
    throw error;
  },
  addFlag: () => {
    throw error;
  }
};
const AppConfigContext = /*#__PURE__*/React.createContext(defaultValue);
export function AppConfigProvider({
  children,
  push: pushProp,
  replace: replaceProp,
  addFlag: addFlagProp
}) {
  const {
    contextEntryPoint
  } = useNavigationState();
  const addFlag = useCallback(props => {
    const {
      type,
      ...rest
    } = props;
    addFlagProp({
      ...rest,
      id: rest.id ? `${rest.id}.${Date.now()}` : Date.now(),
      type,
      appearance: 'normal',
      icon: getTypeIcon(type)
    });
  }, [addFlagProp]);
  const push = useCallback(path => {
    const finalPath = prefixWithContextEntryPoint(path, contextEntryPoint);
    return pushProp(finalPath);
  }, [pushProp, contextEntryPoint]);
  const replace = useCallback(path => {
    const finalPath = prefixWithContextEntryPoint(path, contextEntryPoint);
    return replaceProp(finalPath);
  }, [contextEntryPoint, replaceProp]);
  const configValue = useMemo(() => ({
    addFlag,
    push,
    replace
  }), [addFlag, push, replace]);
  return /*#__PURE__*/React.createElement(AppConfigContext.Provider, {
    value: configValue
  }, children);
}
const useAppConfigProvider = () => React.useContext(AppConfigContext);
export const useNavigationActions = () => {
  const {
    push,
    replace
  } = useAppConfigProvider();
  return {
    push,
    replace
  };
};
export const useAddFlag = () => {
  const {
    addFlag
  } = useAppConfigProvider();
  return addFlag;
};